export const ErrorFilled = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM22.9403 21.5261L10.4991 9.08489L9.08489 10.4991L21.5261 22.9403L22.9403 21.5261Z" fill="currentColor"/>
</svg>`;
